import React, { AnchorHTMLAttributes } from "react";

/**
 * Generally should not be used directly.
 * Use our custom Link tag.
 */
const OutboundLink = (props: OutboundLinkProps) => {
  const {
    gtagAction = "click",
    gtagCategory = "outbound",
    gtagLabel,
    gtagValue = 1,
    onClick,
    ...otherProps
  } = props;
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a
      {...otherProps}
      onClick={e => {
        // Logic matches Gatsby's gtag plugin but with support for customising the event sent.
        if (typeof onClick === "function") {
          onClick(e);
        }
        let redirect = true;
        if (
          e.button !== 0 ||
          e.altKey ||
          e.ctrlKey ||
          e.metaKey ||
          e.shiftKey ||
          e.defaultPrevented
        ) {
          redirect = false;
        }
        if (props.target && props.target.toLowerCase() !== `_self`) {
          redirect = false;
        }
        const anyWindow = window as any;
        const gtag = (window as any).gtag;
        if (gtag) {
          const event: Record<string, any> = {
            event_category: gtagCategory,
            event_label: gtagLabel || props.href,
            transport_type: redirect ? `beacon` : ``,
            event_callback: () => {
              if (redirect) {
                anyWindow.location = props.href;
              }
            }
          };
          if (gtagValue) {
            event.value = gtagValue;
          }
          gtag("event", gtagAction, event);
        } else {
          if (redirect) {
            anyWindow.location = props.href;
          }
        }
        return false;
      }}
    />
  );
};

export interface OutboundLinkProps
  extends AnchorHTMLAttributes<HTMLAnchorElement> {
  gtagAction?: string;
  gtagCategory?: string;
  gtagLabel?: string;
  gtagValue?: number;
}

export default OutboundLink;
